<template>
    <div class="exam-similar">
        <ui-panel title="试卷相似率" icon="inuc-jishu">
            <div class="similar-wrap" v-loading="loading" element-loading-text="数据分析中">
                <div class="similar-query">
                    <div class="differ">
                        <el-tooltip placement="top-start">
                            <template #content>
                                <div class="tips" style="line-height: 2;">差异值代表两个相似试卷之间的差异情况<br/>取0~10之间的值，值越小代表越相似<br/>"0"为完全一致，"1"为仅有一题不同，依此类推
                                </div>
                            </template>

                            <span class="differ-label">差异值<i class="icon-tip el-icon-info"></i></span>
                        </el-tooltip>

                        <el-input-number v-model="number"
                                         @change="query"
                                         :min="0" :max="10" :precision="0" size="small"></el-input-number>
                    </div>

                    <!--                <el-button class="btn-query" type="primary" size="small" @click="query">查询</el-button>-->
                </div>

                <div class="similar-result" v-if="show">
                    <el-table class="similar-table sc-table"
                              ref="similarTable"
                              :data="tableData"
                              :border="true"
                              :stripe="true"
                              height="300"
                    >
                        <el-table-column label="分组" type="index" width="60" align="center"></el-table-column>

                        <el-table-column label="试卷信息" align="center">
                            <template #default="{row}">
                                <ul class="similar-list">
                                    <li class="similar-item" v-for="item in row" :key="item.id">
                                        <p><span>姓名：</span>{{ item.useName }}</p>
                                        <p><span>错题数：</span>{{ item.error_topic_num }}</p>
                                    </li>
                                </ul>
                            </template>
                        </el-table-column>

                        <el-table-column prop="similar_error_topic_num" label="共同错题数" align="center" width="200px">
                            <template #default="{row}">{{ row[0].similar_error_topic_num }}</template>
                        </el-table-column>

                        <el-table-column :label="$t('c.operation')" align="center" width="100px">
                            <template #default="{row}">
                                <div class="btn-cell">
                                    <i class="nucfont inuc-preview" :title="$t('c.view')"
                                       @click="viewSimilarPaper(row)"></i>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </ui-panel>

        <exam-similar-detail
            v-model="detailDialog"
            :exam-id="examId"
            :paper-type="paperType"
            :user-ids="currentUserIds"
        >
        </exam-similar-detail>

    </div>
</template>

<script>
import ExamSimilarDetail from "./ExamSimilarDetail";
import {Debounce} from '@/utils';

export default {
    props: {
        examId: {
            type: String,
            required: true,
        },

        paperType: {
            type: Number,
            default: 1   // 1理论 3CT 4DR
        }
    },

    components: {
        ExamSimilarDetail
    },

    data() {
        return {
            show: true,
            loading: false,
            number: 0,
            tableData: [],
            detailDialog: false,
            currentUserIds: []
        }
    },

    computed: {},

    mounted() {
        this.query()
    },

    methods: {
        // query() {
        //     this.show = true
        //
        //     this.getData()
        // },

        query: Debounce(function (data) {
            this.show = true
            this.getData()
        }, 600),

        getData() {
            this.loading = true

            this.$api.getExamSimilarList(this.examId, this.number).then(res => {
                this.loading = false

                let data = res.package
                if (!data) {
                    return this.tableData = []
                }

                if (this.paperType === 1) {
                    if (this.number > 0) {
                        let key1 = `${this.number}_different_answer_repetition_detection_result`
                        let key2 = `users_similar_answers_theoretical_all_topic_${this.number}`
                        this.tableData = data[key1][key2]
                    } else {
                        this.tableData = data.identical_answer_repetition_detection_result.users_similar_answers_theoretical_all_topic_0
                    }
                } else {
                    if (this.number > 0) {
                        let key1 = `${this.number}_different_answer_repetition_detection_result`
                        let key2 = `users_similar_answers_picture_topic_${this.number}`
                        this.tableData = data[key1][key2]
                    } else {
                        this.tableData = data.identical_answer_repetition_detection_result.users_similar_answers_picture_topic_0
                    }
                }

            }).catch(() => {
                this.loading = false
            })
        },

        viewSimilarPaper(row) {
            let userIds = row.map(item => item.userId)

            this.currentUserIds = userIds
            this.detailDialog = true
        },
    },
}
</script>

<style lang="scss">
.exam-similar {

    .similar-query {
        display: flex;

        .differ-label {
            margin-right: 10px;

            i {
                color: #999;
            }
        }

        .btn-query {
            margin-left: 16px;
        }
    }


    .similar-result {
        margin-top: 20px;

        .similar-item {
            display: flex;
            padding: 15px 0;

            + .similar-item {
                border-top: 1px solid #EBEEF5;
            }

            p {
                width: 50%;
                padding: 0 20px;
                //text-align: left;
            }

            span {
                display: inline-block;
                color: #999;
            }
        }
    }


    .similar-table {

        .cell, td {
            padding: 0;
        }

    }


}
</style>
